// extracted by mini-css-extract-plugin
export var divider = "styles-module--divider--+eaMw";
export var image = "styles-module--image--yywKA";
export var servItem = "styles-module--serv-item--409iK";
export var servicesAccueil = "styles-module--services-accueil--5WJD4";